import React from 'react'

const OilRecordItem = ({user, date, quantity, ecopoints}) => {
  return (
    <React.Fragment>
        <div>{user}</div>
        <div>{date}</div>
        <div>{quantity}</div>
        <div>{ecopoints}</div>
    </React.Fragment>
  )
}

export default OilRecordItem